import type { Price } from '@noths/polaris-dev-ts-types';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchDeliveryOptions } from 'src/services/delivery-settings/fetchDeliveryOptions';
import { fetchPartnerDeliverySettings } from 'src/services/delivery-settings/fetchPartnerDeliverySettings';
import type { DeliverySettingsAPIDeliveryZone } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryZone';

interface RequestDeliveryZoneOptions {
  productCode: number;
  productPrice: Price;
}

export const requestDeliveryZoneOptions = createAsyncThunk<
  DeliverySettingsAPIDeliveryZone[],
  RequestDeliveryZoneOptions
>('delivery/requestDeliveryZoneOptions', ({ productCode, productPrice }) => {
  return fetchDeliveryOptions(productCode, productPrice);
});

interface RequestPartnerDeliverySettingsOptions {
  partnerID: number;
}

interface RequestPartnerDeliverySettingsPayload {
  overThirtyFree: boolean;
}

export const requestPartnerDeliverySettings = createAsyncThunk<
  RequestPartnerDeliverySettingsPayload,
  RequestPartnerDeliverySettingsOptions
>('delivery/requestPartnerDeliverySettings', async ({ partnerID }) => {
  const { overThirtyFree } = await fetchPartnerDeliverySettings(partnerID);

  return { overThirtyFree };
});
